import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';
import { isBoolean } from '../utils/type';


// 数据服务数据过滤聚合处理专用函数，返回数据服务中，指定数据对象符合过滤条件的数组元素的集合。
export function DS_FIND(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (![2, 3, 4].includes(args.length)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的参数只接受两个三个或四个`, token.position);
  }

  const targetArg = args[0];

  if (!targetArg.type) {
    throw new InferenceError('function-argument-error', `${functionName} 函数第一个参数fqn路径不合法`, token.position);
  }

  if (!targetArg.token || !['ModelProperty'].includes(targetArg.token.type)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数第一个参数必须为fqn路径`, token.position);
  }

  const conditionArg = args[1];
  if (!isBoolean(conditionArg, false)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数第二个参数返回类型必须为布尔类型`, token.position);
  }

  const sortArg = args[2];
  if (sortArg) {
    if ((!sortArg.token || !['ModelProperty'].includes(sortArg.token.type))) {
      throw new InferenceError('function-argument-error', `${functionName} 函数第三个参数必须为fqn路径`, token.position);
    }
    if (sortArg.token.raw.includes('[]')) {
      throw new InferenceError('function-argument-error', `${functionName} 函数第三个参数不能为数组路径`, token.position);
    }
  }

  const limitArg = args[3];

  if (limitArg && !(limitArg.type === 'Integer' && limitArg.token && limitArg.token.isAtom && limitArg.token.type === 'Integer')) {
    throw new InferenceError('function-argument-error', `${functionName} 函数第四个参数必须整数常量`, token.position);
  }

  if (targetArg.isArray) {
    return targetArg;
  } else {
    // const targetOptions = { ...targetArg };
    // delete targetOptions.type;
    // return TypeGenerator.ArrayOf(targetArg.type, {
    //   ...targetOptions
    // });
    return { ...targetArg, isArray: true };
  }

}
